import React from 'react'
import SideMenu from './Components/SideMenu'
import { useGlobalContext } from '../../../context'
import { useLocation } from 'react-router-dom';
import MofReportDashboard from './MofReportDashboard';
import Dashboard from "../MOF/Dashboard";
import AddVarites from "../MOF/DashboardTabs/AddVarites";
import AddSections from "../MOF/DashboardTabs/AddSections";

import AddActivityType from './DashboardTabs/AddActivityType';
import IncomeTaxReport from './DashboardTabs/IncomeTaxReport/IncomeTaxReport';
import IncomeTaxReportDataGrid from './DashboardTabs/IncomeTaxReport/IncomeTaxReportDataGrid';
import IncomeEstimateForm from './DashboardTabs/IncomeTaxReport/IncomeEstimateForm';
import OtherBusinessForm from './DashboardTabs/IncomeTaxReport/OtherBusinessForm';
import IncomeEstimateClass from './DashboardTabs/IncomeTaxReport/IncomeEstimateClass';
import StageTransactionTypeGrid from './DashboardTabs/TransactionTypes/StageTransactionTypeGrid';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import {Container as MuiContainer} from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import AddBranch from './DashboardTabs/AddBranch';
import AddRole from './DashboardTabs/AddRole';
import AddPermission from './DashboardTabs/AddPermission';
import AddStage from './DashboardTabs/AddStage';
import AddTransactionType from './DashboardTabs/AddTransactionType';
import AddApproval from './DashboardTabs/AddApproval';
import AddUser from './DashboardTabs/AddUser';
const pages = ['Products', 'Pricing', 'Blog'];
const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];
export default function Container() {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
  
    const handleOpenNavMenu = (event) => {
      setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
      setAnchorElUser(event.currentTarget);
    };
  
    const handleCloseNavMenu = () => {
      setAnchorElNav(null);
    };
  
    const handleCloseUserMenu = () => {
      setAnchorElUser(null);
    };
 const {
    setInactive,
    inactive,
 }=useGlobalContext();
 const location =useLocation();

 const renderWhichComponent=()=>{
   if(location.pathname=="/report-dashboard-mof")
    return <MofReportDashboard inactive={inactive} />
   else if(
   location.pathname=="/addGroups-dashboard-moh")
      return <Dashboard inactive={inactive} />
 
   else if(
   location.pathname=="/GroupsOfCarriers")
    return <Dashboard inactive={inactive} />

   else if(
   location.pathname=="/AddVarieties")
   return <AddVarites inactive={inactive} />

   else if(
   location.pathname=="/AddActivityType")
   return <AddActivityType inactive={inactive} />

   else if(
   location.pathname=="/income_tax_report")
   return <IncomeTaxReportDataGrid inactive={inactive} />

   else if(
   location.pathname=="/insert_income_tax_report")
   return <IncomeTaxReport inactive={inactive} />

   else if(
   location.pathname=="/income_estimate_form")
   return <IncomeEstimateForm inactive={inactive} />

   else if(
   location.pathname=="/other_business")
   return <OtherBusinessForm inactive={inactive} />

   else if(location.pathname=="/income_estimate_class")
   return <IncomeEstimateClass inactive={inactive} />

   else if(location.pathname=="/add_branch")
   return <AddBranch inactive={inactive} />
   else if(location.pathname=="/add_role")
   return <AddRole inactive={inactive} />
   else if(location.pathname=="/add_permission")
   return <AddPermission inactive={inactive} />
   else if(location.pathname=="/add_stage")
   return <AddStage inactive={inactive} />
   else if(location.pathname=="/add_transaction_type")
   return <AddTransactionType inactive={inactive} />
   else if(location.pathname=="/add_approval_status")
   return <AddApproval inactive={inactive} />
   else if(location.pathname=="/add_user")
   return <AddUser inactive={inactive} />
   else if(location.pathname=="/stage_transaction_type")
   return <StageTransactionTypeGrid inactive={inactive} />
   else if(location.pathname=="/AddSections")
   return <AddSections inactive={inactive} />

 }

  return (
    <div>

<div className="Dashboard_MOF px-0 mx-0">
      <div className="container-fluid w-100 mx-0 px-0">
        <div className="row rowContainer mx-0 d-flex " >
          <div className="col-md-12 mx-0 px-0" style={{flexDirection:"row-reverse",display:'none'}}>
             <AppBar position="relative"  >
                <Toolbar disableGutters style={{height:"100px",backgroundColor:'rgb(255,255,255)'}} >
                  {/* <AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} /> */}
                  <Typography
                    variant="h6"
                    noWrap
                    component="a"
                    href="/"
                    sx={{
                      mr: 2,
                      display: { xs: 'none', md: 'flex' },
                      fontFamily: 'monospace',
                      fontWeight: 700,
                      letterSpacing: '.3rem',
                      color: 'inherit',
                      textDecoration: 'none',
                    }}
                  >
                    LOGO
                  </Typography>

                  <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                    <IconButton
                      size="large"
                      aria-label="account of current user"
                      aria-controls="menu-appbar"
                      aria-haspopup="true"
                      onClick={handleOpenNavMenu}
                      color="inherit"
                    >
                      <MenuIcon />
                    </IconButton>
                    <Menu
                      id="menu-appbar"
                      anchorEl={anchorElNav}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      open={Boolean(anchorElNav)}
                      onClose={handleCloseNavMenu}
                      sx={{
                        display: { xs: 'block', md: 'none' },
                      }}
                    >
                      {pages.map((page) => (
                        <MenuItem key={page} onClick={handleCloseNavMenu}>
                          <Typography textAlign="center">{page}</Typography>
                        </MenuItem>
                      ))}
                    </Menu>
                  </Box>
                  <AdbIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1,visibility: 'hidden' }} />
                  <Typography
                    variant="h5"
                    noWrap
                    component="a"
                    href=""
                    sx={{
                      mr: 2,
                      display: { xs: 'flex', md: 'none' },
                      flexGrow: 1,
                      fontFamily: 'monospace',
                      fontWeight: 700,
                      letterSpacing: '.3rem',
                      color: 'inherit',
                      textDecoration: 'none',
                    }}
                  >
                    LOGO
                  </Typography>
                  <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } ,visibility: 'hidden'}}>
                    {pages.map((page) => (
                      <Button
                        key={page}
                        onClick={handleCloseNavMenu}
                        sx={{ my: 2, color: 'white', display: 'block' }}
                      >
                        {page}
                      </Button>
                    ))}
                  </Box>

                  <Box sx={{ flexGrow: 0,mr:4 }}>
                    <Tooltip title="Open settings">
                      <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                        <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      sx={{ mt: '45px' }}
                      id="menu-appbar"
                      anchorEl={anchorElUser}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      open={Boolean(anchorElUser)}
                      onClose={handleCloseUserMenu}
                    >
                      {settings.map((setting) => (
                        <MenuItem key={setting} onClick={handleCloseUserMenu}>
                          <Typography textAlign="center">{setting}</Typography>
                        </MenuItem>
                      ))}
                    </Menu>
                  </Box>
                </Toolbar>
             </AppBar>
          </div>
          <div className="col-md-12 col-xl-12 w-100 d-flex flex-column justify-content-center align-items-end  paddingForm">
            {/* <AddActivityTypeForm inactive={inactive} /> */}
            {/* <MofReportDashboard inactive={inactive} /> */}
             
            {renderWhichComponent()}
          </div>
          
          <SideMenu inactive={inactive} setInactiveFromProps={setInactive}/>
        </div>
      </div>
    </div>
        
        

    </div>
  )
}
